import type { ModuleManifest } from '@platform/shell';

const manifest: ModuleManifest = {
  id: 'implementation',
  label: 'Implementation',
  product: 'implementation',
  order: 2,
  basePath: '/implementation',
  home: '/implementation',
  load: () => import('./src/platform-entry.tsx'),
};

export default manifest;
